export const getLessonName = (lesson: { full_name: string | null; name: string }): string => {
    return lesson.full_name || lesson.name;
};
